import { shopOwnerApi } from '../api/shopOwnerApi';

export const shopOwnerRepo = {
    getAll: (params) => shopOwnerApi.getAll(params),

    getById: (shopOwnerId) => shopOwnerApi.getById(shopOwnerId),

    getByShop: (shopId, params) => shopOwnerApi.getByShop(shopId, params),

    getTotalByShop: (shopId) => shopOwnerApi.getTotalByShop(shopId),

    getAvailableOwners: (params) => shopOwnerApi.getAvailableOwners(params),

    create: (data) => shopOwnerApi.create(data),

    update: (shopOwnerId, data) => shopOwnerApi.update(shopOwnerId, data),

    toggleStatus: (shopOwnerId) => shopOwnerApi.toggleStatus(shopOwnerId),

    setStatus: (shopOwnerId, status) => shopOwnerApi.setStatus(shopOwnerId, status),
};